import React from 'react';
import {Flex, Tag, Icon, DatePickerPopup} from 'components';
import {over, stopPropagation, openPopup, useNamedSelector} from 'helpers';
import css from './date-navigator.module.scss';

export function DateNavigator({ className, value, setValue }) {
  const { today } = useNamedSelector('calendar.days');
  const differentYear = value.year() != today.year();
  return (
    <Flex className={['middle', 'small-gutter', css.navigator, className]}>
      <Tag className="secondary-tag" onClick={openPopup(DatePickerPopup, {value, setValue, required: true, monthsShown: 2})}>
        <Icon name="chevron-left" onClick={over(stopPropagation, () => setValue(value.clone().subtract('1', 'day')))} />
        <b className={css.date}>{ value.format(differentYear ? 'MMM D, YYYY' : 'MMM D') }</b>
        <Icon name="chevron-right" onClick={over(stopPropagation, () => setValue(value.clone().add('1', 'day')))} />
      </Tag>
      { !today.isSame(value) &&
        <Icon name="return" className="secondary" onClick={over(stopPropagation, () => setValue(today))} />
      }
    </Flex>
  );
}
